export const SIZE_INFO_MESSAGES = {
  GUIDE_HIGHLIGHT: '하늘색은 내 실측과 가장 가까운 사이즈예요.',
  GUIDE_NO_HIGHLIGHT: '비교 시, 하늘색으로 가장 가까운 사이즈가 표시돼요.',
  DEFAULT_DESCRIPTION: '소재나 측정 방식에 따라 차이가 있을 수 있어요.',
} as const;
